import React from 'react';

export function renderMessageWithLink(message: string, link: string) {
  const [preLinkText, rest] = message.split('<link>');
  const [linkText, postLinkText] = rest.split('</link>');

  const preTextParts = preLinkText.split('<br><br>');
  const hasMultiplePreParts = preTextParts.length > 1;

  return (
    <span>
      {preTextParts.map((part, index) => (
        <React.Fragment key={index}>
          {part}
          {index === 0 && hasMultiplePreParts && (
            <>
              <br />
              <br />
            </>
          )}
          {index === 1 && ' '}
        </React.Fragment>
      ))}
      <a href={link} target="_blank" rel="noreferrer">
        <b>
          <u>{linkText}</u>
        </b>
      </a>{' '}
      {postLinkText}
    </span>
  );
}
